import S_base from '@/services/wasaapi/__base';

export default {
  async delete(idtfItemId) {
    try {
      await S_base.delete({ modelName: 'act_idtf_assignment_item', modelId: idtfItemId });
    } catch (error) {
      alert(error);
    }
  },
};
